import clsx from "clsx";
import React, { FC } from "react";

import { useHeaderMenu } from "../../../../hooks/use-header-menu";
import { HeaderMenuItemDetailTitle } from "../header-menu-item-detail-title";
import { HeaderMenuItemTab } from "./header-menu-item-tab";

export interface HeaderMenuItemDetailProps {
  className?: string;
}

export const HeaderMenuItemDetail: FC<HeaderMenuItemDetailProps> = ({ className }) => {
  const { expandedEditorialItem } = useHeaderMenu();
  if (!expandedEditorialItem) return null;

  const tabsCount = (expandedEditorialItem.tabs ?? []).length;

  return (
    <div className={clsx("flex flex-col gap-4 w-full", className)}>
      {expandedEditorialItem.title && (
        <HeaderMenuItemDetailTitle title={expandedEditorialItem.title} />
      )}
      {expandedEditorialItem.tabs?.map(
        (tab, i) =>
          tab && (
            <div className="flex flex-col gap-4 pl-9" key={tab.id}>
              <HeaderMenuItemTab tab={tab} isSingleTab={tabsCount > 1} />
              {i < tabsCount - 1 && <hr />}
            </div>
          )
      )}
    </div>
  );
};
